import { z } from 'zod';

export const ENTERPRISE_IDS_FIELD_NAME = 'enterpriseIds';
export const ENTERPRISE_GROUPS_IDS_FIELD_NAME = 'enterpriseGroupeIds';

export const enterpriseValidationSchema = z.object({
    [ENTERPRISE_IDS_FIELD_NAME]: z.array(z.string()).nonempty(),
});

export const enterpriseGroupsValidationSchema = z.object({
    [ENTERPRISE_GROUPS_IDS_FIELD_NAME]: z.array(z.string()).nonempty(),
});

export type EnterpriseFormValues = z.infer<typeof enterpriseValidationSchema>;
export type EnterpriseGroupsFormValues = z.infer<typeof enterpriseGroupsValidationSchema>;
